var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightBlueCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Light Blue Circle",
    viewBox: "0 0 23.041 23.041",
    width: 23.041,
    height: 23.041,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "light_blue_circle",
    fill: "#1DA1F2",
    cx: 11.5205,
    cy: 11.5205,
    r: 11.5205
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightBlueCircle);
export default __webpack_public_path__ + "static/media/Light_Blue_Circle.1630ed5228afc5b078b67e7cadf241c6.svg";
export { ForwardRef as ReactComponent };